import { powerBi } from './powerBi';
import { theme } from './theme';

export const atoms = {
  theme,
  powerBi,
};
